const styles = (theme) => ({
    item: {
        textAlign: 'center',
        '& button': {
            margin: '0 !important',
        },
    },
    smallItem: {
        margin: '0 !important',
        paddingTop: '4px !important',
        paddingBottom: '4px !important',
    },
    register: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
        fontSize: '.9rem',
        margin: '.5em 0 1em',
        alignSelf: 'flex-end',
    },
    forgotPassword: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
        fontSize: '.9rem',
        margin: '.5em 1em 1em',
        display: 'block',
        float: 'right',
    },
    right: {
        float: 'right',
    },
    textBlue: {
        color: '#3372b8',
    },
    boxTextField: {
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: '0px !important',
    },
    icone: {
        margin: '20px 10px 0 0',
    },
    box: {
        display: 'block',
        padding: '12px 0 5px 50px',
        flex: 1,
        '& button': {
            margin: '0 !important',
        },
    },
    btnEsqueciSenha: {},
    loginButton: {
        width: '50%',
        color: 'white',
        borderRadius: '20px',
        textTransform: 'uppercase',
        boxShadow: '0 5px 10px rgba(0,0,0,.4)',
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
    },
});

export default styles;
